export default __webpack_public_path__ + "static/media/number-of-poer.5a6922e3.jpg";